import { fetchFormConfig, fetchSubmissionStatus, submitUndertakingForm } from '../../clients/undertaking-form'
import { UndertakingFormConfig, UndertakingFormStatus, SubmitFormData, SubmissionResponse } from './types'

class UndertakingFormRepository {
    async getFormConfig(): Promise<UndertakingFormConfig> {
        const response = await fetchFormConfig()
        return response
    }

    async getSubmissionStatus(): Promise<UndertakingFormStatus> {
        const response = await fetchSubmissionStatus()
        return response
    }

    async submitForm(formData: SubmitFormData): Promise<SubmissionResponse> {
        const response = await submitUndertakingForm(formData)
        return response
    }
}

export default UndertakingFormRepository
